import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';
import { AllBranchesBalanceComponent } from './all-branches-balance.component';

@NgModule({
  declarations: [AllBranchesBalanceComponent],
  imports: [
    CommonModule,
    NgbTooltipModule,
    PipesModule,
    SharedComponentsModule,
  ],
  exports: [AllBranchesBalanceComponent]
})
export class AllBranchesBalanceModule { }
